import { z } from 'zod'

/** Seconds value stored as numeric(16,6); accept string or number in JSON. */
export const CoefficientSecondsSchema = z.union([
  z.string().regex(/^\d+(\.\d+)?$/, 'Must be a non-negative decimal'),
  z.number().nonnegative(),
]).transform(value => (typeof value === 'number' ? String(value) : value))

export const CreateCoefficientInputSchema = z.object({
  effectiveFromUtc: z.string().min(1).describe('Effective instant: DD-MM-YYYY (midnight Australia/Sydney) or ISO-8601 datetime'),
  baseOverheadSeconds: CoefficientSecondsSchema,
  pouchSSecondsPerUnit: CoefficientSecondsSchema,
  pouchMSecondsPerUnit: CoefficientSecondsSchema,
  pouchLSecondsPerUnit: CoefficientSecondsSchema,
  extrasSecondsPerUnit: CoefficientSecondsSchema,
  mixedPenaltyPouchSSeconds: CoefficientSecondsSchema,
  mixedPenaltyPouchMSeconds: CoefficientSecondsSchema,
  mixedPenaltyPouchLSeconds: CoefficientSecondsSchema,
  mixedPenaltyFlatSeconds: CoefficientSecondsSchema,
  createdBy: z.string().min(1).describe('Author of this coefficient version (e.g. email)'),
})
export type CreateCoefficientInput = z.infer<typeof CreateCoefficientInputSchema>

export const CoefficientSchema = z.object({
  id: z.string().uuid(),
  effectiveFromUtc: z.string().datetime({ offset: true }),
  baseOverheadSeconds: z.string(),
  pouchSSecondsPerUnit: z.string(),
  pouchMSecondsPerUnit: z.string(),
  pouchLSecondsPerUnit: z.string(),
  extrasSecondsPerUnit: z.string(),
  mixedPenaltyPouchSSeconds: z.string(),
  mixedPenaltyPouchMSeconds: z.string(),
  mixedPenaltyPouchLSeconds: z.string(),
  mixedPenaltyFlatSeconds: z.string(),
  createdBy: z.string(),
  createdTimeUtc: z.string().datetime({ offset: true }),
  updatedTimeUtc: z.string().datetime({ offset: true }),
})
export type Coefficient = z.infer<typeof CoefficientSchema>

export const GetCoefficientEffectiveAtQuerySchema = z.object({
  effectiveAt: z.string().min(1).describe('Lookup instant: DD-MM-YYYY (midnight Australia/Sydney) or ISO-8601; returns row effective at or before this time'),
})
export type GetCoefficientEffectiveAtQuery = z.infer<typeof GetCoefficientEffectiveAtQuerySchema>

export const CoefficientListResponseSchema = z.array(CoefficientSchema)
export type CoefficientListResponse = z.infer<typeof CoefficientListResponseSchema>
